import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import { SITENAMEALIAS, ASSETS } from "../utils/init";
import { Link } from "react-router-dom";
import {
  showToast,
  showHttpError,
  currentPageAccess,
  handleCurrencyDetiails,
} from "../utils/library";
import {
  FetchMerchantStatus,
  getCryptoAddress,
  AddCryptoAddress,
  FetchUsdBtcLedgerAmount,
  isCryptoAddrValid,
} from "../utils/service";
import BtcLogo from "../assets/images/currency/BTC.svg";
import EthLogo from "../assets/images/currency/ETH.svg";
import LtcLogo from "../assets/images/currency/LTC.svg";
import BchLogo from "../assets/images/currency/BCH.svg";
import { Modal } from "react-bootstrap";

const styles = {
  pageWrapper: { padding: "36px 24px 60px" },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    padding: "28px 32px",
  },
  cardHeaderRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "24px",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    color: "var(--btn-color)",
    flexShrink: 0,
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 15%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
  },
  cardTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
    letterSpacing: "-0.2px",
  },
  cardSubtitle: { fontSize: "12px", opacity: 0.5, marginTop: "2px" },
  table: { width: "100%", borderCollapse: "separate", borderSpacing: "0" },
  th: {
    padding: "10px 16px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    opacity: 0.5,
    color: "var(--text-color)",
    borderBottom: "1px solid var(--body-color-less2)",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "14px 16px",
    fontSize: "14px",
    color: "var(--text-color)",
    borderBottom: "1px solid var(--body-color-less2)",
    verticalAlign: "middle",
  },
  assetRow: { display: "flex", alignItems: "center", gap: "12px" },
  assetIcon: { width: "32px", height: "32px", borderRadius: "50%" },
  assetName: { fontWeight: "600", fontSize: "14px" },
  assetCode: { fontSize: "12px", opacity: 0.5 },
  btnPrimary: {
    padding: "9px 24px",
    background: "var(--btn-color)",
    color: "#fff",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    transition: "opacity 0.2s",
  },
  btnSecondary: {
    padding: "9px 24px",
    background: "transparent",
    color: "var(--text-color)",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "1px solid var(--body-color-less2)",
    cursor: "pointer",
    transition: "opacity 0.2s",
  },
  emptyState: { textAlign: "center", padding: "48px 24px", opacity: 0.5 },
  emptyIcon: { fontSize: "40px", marginBottom: "12px", opacity: 0.3 },
  modalOverlay: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    overflow: "hidden",
  },
  modalHeader: {
    padding: "24px 28px 0",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  modalTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "var(--text-color)",
  },
  modalBody: { padding: "20px 28px 28px" },
  modalFooter: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "20px",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    transition: "border-color 0.2s",
  },
  label: {
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    opacity: 0.7,
    color: "var(--text-color)",
    marginBottom: "6px",
  },
  formGroup: { marginBottom: "18px" },
  iconPurple: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 15%, transparent), color-mix(in srgb, #8b5cf6 5%, transparent))",
    color: "#8b5cf6",
  },
};

class CryptoAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      pageNo: 1,
      noOfItemsPerPage: 20,
      showAddAddressModal: false,
      selectedAsset: {},
      currency_id: "",
      selectedAddress: "",
      selectedAddressERC: "",
      selectedAddressTRC: "",
      selectedAddressName: "",
      selectedMemo: "",
      addressValidStatus: null,
      addressValidStatusERC: null,
      addressValidStatusTRC: null,
      validatingAddress: false,
      validatingAddressERC: false,
      validatingAddressTRC: false,
      autoWithdrawNetwork: "ERC",
      isEnabledAutoWithdraw: 1,
      assets: [],
      permission: "",
      addressNameError: "",
      memoError: "",
      hadInitialNativeAddress: false,
      hadInitialERCAddress: false,
      hadInitialTRCAddress: false,
    };
  }

  handleAddressNameKeyUp = (e) => {
    const value = e.target.value;
    if (!value) {
      this.setState({ addressNameError: "Address Name cannot be empty" });
    } else {
      const addressNameRegex = /^[a-zA-Z0-9_ ]{1,100}$/;
      if (!addressNameRegex.test(value)) {
        this.setState({
          addressNameError:
            "Letters, numbers, spaces, and underscores only. Max 100 characters.",
        });
      } else {
        this.setState({ addressNameError: "" });
      }
    }
  };

  handleMemoKeyUp = (e) => {
    const value = e.target.value;
    if (
      (this.state.selectedAsset.assetCode === "HCX" ||
        this.state.selectedAsset.assetCode === "XRP") &&
      !value
    ) {
      this.setState({ memoError: "Memo/Destination Tag is required" });
    } else if (value) {
      const memoRegex = /^[a-zA-Z0-9]{1,30}$/;
      if (!memoRegex.test(value)) {
        this.setState({
          memoError:
            "Letters and numbers only. No spaces or special characters. Max 30 characters.",
        });
      } else {
        this.setState({ memoError: "" });
      }
    } else {
      this.setState({ memoError: "" });
    }
  };

  validateCryptoAddress = (networkType = "") => {
    const {
      selectedAddress,
      selectedAddressERC,
      selectedAddressTRC,
      selectedAsset,
      currency_id,
      selectedMemo,
    } = this.state;

    let addressToValidate = selectedAddress;
    let statePrefix = "";

    if (String(currency_id) === "16") {
      if (networkType === "ERC") {
        addressToValidate = selectedAddressERC;
        statePrefix = "ERC";
      } else if (networkType === "TRC") {
        addressToValidate = selectedAddressTRC;
        statePrefix = "TRC";
      }
    }

    if (!addressToValidate) {
      this.setState({ [`addressValidStatus${statePrefix}`]: null });
      return;
    }

    const payload = {
      address: addressToValidate,
      currency: selectedAsset?.assetCode,
      currencyId: currency_id,
      tokenType: networkType || selectedAsset?.network?.[0] || "",
      memo: selectedMemo || "",
    };

    this.setState({
      [`validatingAddress${statePrefix}`]: true,
      [`addressValidStatus${statePrefix}`]: null,
    });

    isCryptoAddrValid(payload)
      .then((res) => {
        const response = res.data[0];
        this.setState({
          [`validatingAddress${statePrefix}`]: false,
          [`addressValidStatus${statePrefix}`]: response.error === "1" ? "invalid" : "valid",
        });
      })
      .catch(() => {
        this.setState({
          [`validatingAddress${statePrefix}`]: false,
          [`addressValidStatus${statePrefix}`]: "invalid",
        });
      });
  };

  handleGetAddress = (param) => {
    if (this.state.permission == "WRITE") {
      let payload = {
        currency_id: param.assetId,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      this.setState({
        showLoader: true,
        selectedAddress: "",
        selectedAddressERC: "",
        selectedAddressTRC: "",
        addressValidStatus: null,
        addressValidStatusERC: null,
        addressValidStatusTRC: null,
      });

      getCryptoAddress(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            if (res.data && res.data.length > 0) {
              const responses = res.data;
              const statusObj = responses[responses.length - 1];

              if (statusObj.error != "0") {
                showToast("error", statusObj.error_msg);
              } else {
                let ercAddr = "";
                let trcAddr = "";
                let nativeAddr = "";
                let addressName = "";
                let memo = "";
                let autoNet = "ERC";
                let isEnabledAutoWithdraw = 1;

                // Iterate through all items except the last one (error object)
                for (let i = 0; i < responses.length - 1; i++) {
                  const r = responses[i];
                  if (r.network_type === "ERC") {
                    ercAddr = r.bitcoin_address;
                    if (r.isEnabledAutoWithdraw === 1) autoNet = "ERC";
                  } else if (r.network_type === "TRC") {
                    trcAddr = r.bitcoin_address;
                    if (r.isEnabledAutoWithdraw === 1) autoNet = "TRC";
                  } else if (r.network_type === "NATIVE" || !r.network_type) {
                    nativeAddr = r.bitcoin_address;
                    isEnabledAutoWithdraw = r.isEnabledAutoWithdraw ?? 1;
                  }

                  // Pick general fields from the first data object
                  if (i === 0) {
                    addressName = r.address_name || "";
                    memo = r.memo || "";
                  }
                }

                this.setState({
                  selectedAsset: param,
                  currency_id: param.assetId,
                  showAddAddressModal: true,
                  selectedAddress: nativeAddr,
                  selectedAddressERC: ercAddr,
                  selectedAddressTRC: trcAddr,
                  selectedAddressName: addressName,
                  selectedMemo: memo,
                  autoWithdrawNetwork: autoNet,
                  isEnabledAutoWithdraw: isEnabledAutoWithdraw,
                  hadInitialNativeAddress: !!nativeAddr,
                  hadInitialERCAddress: !!ercAddr,
                  hadInitialTRCAddress: !!trcAddr,
                });
              }
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      showToast("error", "You need write access to perform this operation");
    }
  };

  handleSaveAddress = () => {
    if (this.state.permission != "WRITE") {
      showToast("error", "You need write access to perform this operation");
      return;
    }

    const {
      selectedAddressName,
      selectedAddress,
      selectedAddressERC,
      selectedAddressTRC,
      selectedMemo,
      selectedAsset,
      addressNameError,
      memoError,
      currency_id,
      autoWithdrawNetwork,
      isEnabledAutoWithdraw,
    } = this.state;

    if (!selectedAddressName || addressNameError) {
      showToast("error", addressNameError || "Address Name cannot be empty");
      return;
    }

    const isUSDT = String(currency_id) === "16";

    if (isUSDT) {
      if (this.state.hadInitialERCAddress && !selectedAddressERC) {
        showToast("error", "USDT ERC Address cannot be removed once set");
        return;
      }
      if (this.state.hadInitialTRCAddress && !selectedAddressTRC) {
        showToast("error", "USDT TRC Address cannot be removed once set");
        return;
      }
      if (!selectedAddressERC && !selectedAddressTRC) {
        showToast("error", "At least one address (ERC or TRC) must be provided");
        return;
      }
    } else {
      if (this.state.hadInitialNativeAddress && !selectedAddress) {
        showToast("error", "Address cannot be removed once set");
        return;
      }
      if (!selectedAddress) {
        showToast("error", "Address cannot be empty");
        return;
      }
    }

    if (
      (selectedAsset.assetCode === "HCX" || selectedAsset.assetCode === "XRP") &&
      (!selectedMemo || memoError)
    ) {
      showToast("error", memoError || "Memo/Destination Tag is required");
      return;
    }

    if (selectedMemo && memoError) {
      showToast("error", memoError);
      return;
    }

    this.setState({ showLoader: true });

    const validateAddress = (addr, network) => {
      if (!addr) return Promise.resolve({ error: "0" });
      const payload = {
        address: addr,
        currency: selectedAsset.assetCode,
        currencyId: currency_id,
        tokenType: network || selectedAsset?.network?.[0] || "",
        memo: selectedMemo || "",
      };
      return isCryptoAddrValid(payload).then((res) => res.data[0]);
    };

    let validationPromise;
    if (isUSDT) {
      validationPromise = Promise.all([
        validateAddress(selectedAddressERC, "ERC"),
        validateAddress(selectedAddressTRC, "TRC"),
      ]);
    } else {
      validationPromise = Promise.all([validateAddress(selectedAddress, "")]);
    }

    validationPromise
      .then((results) => {
        const hasInvalid = results.some((res) => res.error === "1");
        if (hasInvalid) {
          this.setState({ showLoader: false });
          showToast("error", "Invalid crypto address detected");
          return;
        }

        let finalPayload;
        const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");

        if (isUSDT) {
          finalPayload = [];
          if (selectedAddressERC) {
            finalPayload.push({
              crypto_address: selectedAddressERC,
              address_name: selectedAddressName,
              currency_id: 16,
              merchant_id: merchant_id,
              networkType: "ERC",
              isEnabledAutoWithdraw: autoWithdrawNetwork === "ERC" ? 1 : 0,
              memo: "",
            });
          }
          if (selectedAddressTRC) {
            finalPayload.push({
              crypto_address: selectedAddressTRC,
              address_name: selectedAddressName,
              currency_id: 16,
              merchant_id: merchant_id,
              networkType: "TRC",
              isEnabledAutoWithdraw: autoWithdrawNetwork === "TRC" ? 1 : 0,
              memo: "",
            });
          }
        } else {
          finalPayload = [
            {
              crypto_address: selectedAddress,
              address_name: selectedAddressName,
              currency_id: selectedAsset.assetId,
              merchant_id: merchant_id,
              memo: selectedMemo || "",
              networkType: "NATIVE",
              isEnabledAutoWithdraw: 0,
            },
          ];
        }

        return AddCryptoAddress(finalPayload);
      })
      .then((res) => {
        if (!res) return;

        this.setState({ showLoader: false });
        const response = res.data[0];

        if (response.error != "0") {
          showToast("error", response.error_msg);
        } else {
          this.setState({
            selectedAsset: {},
            showAddAddressModal: false,
            selectedAddress: "",
            selectedAddressERC: "",
            selectedAddressTRC: "",
            selectedAddressName: "",
            selectedMemo: "",
            addressValidStatus: null,
            addressValidStatusERC: null,
            addressValidStatusTRC: null,
            addressNameError: "",
            memoError: "",
            hadInitialNativeAddress: false,
            hadInitialERCAddress: false,
            hadInitialTRCAddress: false,
          });

          showToast("success", "Address saved successfully");
          this.handleRenderAssets();
        }
      })
      .catch((err) => {
        this.setState({ showLoader: false });
        showHttpError(err);
      });
  };

  handleRenderAssets = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          console.log(response);
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (String(coinBalance[i].currency_type) === "2") {
                    let obj = {
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    };
                    arr.push(obj);
                  }
                }
              }

              this.setState(
                {
                  assets: arr,
                },
                () => {
                  console.log(this.state.assets);
                  localStorage.setItem(
                    SITENAMEALIAS + "_assets",
                    JSON.stringify(this.state.assets)
                  );
                }
              );
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  componentDidMount() {
    this.handleRenderAssets();
    this.setState({
      permission: currentPageAccess(),
    });
  }

  renderAddressInput = (network = "", label = "") => {
    const { currency_id } = this.state;
    const isUSDT = String(currency_id) === "16";
    const statePrefix = network === "ERC" ? "ERC" : network === "TRC" ? "TRC" : "";
    const addressValue = isUSDT
      ? network === "ERC"
        ? this.state.selectedAddressERC
        : this.state.selectedAddressTRC
      : this.state.selectedAddress;
    const validating = this.state[`validatingAddress${statePrefix}`];
    const validStatus = this.state[`addressValidStatus${statePrefix}`];

    return (
      <div style={styles.formGroup}>
        <label style={styles.label}>{label || `${this.state.selectedAsset.assetName} Address`}</label>
        <input
          type="text"
          style={styles.input}
          placeholder={`Enter ${label || this.state.selectedAsset.assetName} Address`}
          value={addressValue}
          onChange={(e) => {
            const val = e.target.value;
            if (isUSDT) {
              this.setState({
                [`selectedAddress${statePrefix}`]: val,
                [`addressValidStatus${statePrefix}`]: null,
              });
            } else {
              this.setState({
                selectedAddress: val,
                addressValidStatus: null,
              });
            }
          }}
          onBlur={() => this.validateCryptoAddress(network)}
        />
        {validating && (
          <div style={{ fontSize: "12px", marginTop: "6px", opacity: 0.6 }}>Validating...</div>
        )}
        {!validating && validStatus === "valid" && (
          <div
            style={{
              fontSize: "12px",
              marginTop: "6px",
              color: "#16a34a",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <i className="fa fa-check-circle"></i>
            Valid Address
          </div>
        )}
        {!validating && validStatus === "invalid" && (
          <div
            style={{
              fontSize: "12px",
              marginTop: "6px",
              color: "#dc2626",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <i className="fa fa-times-circle"></i>
            Invalid Address
          </div>
        )}

        {/* Automatic Withdrawal Checkbox */}
        {isUSDT && (
          <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              id={`autoWithdraw${statePrefix}`}
              disabled={!addressValue || validStatus === "invalid"}
              checked={this.state.autoWithdrawNetwork === network}
              onChange={(e) => {
                if (e.target.checked) {
                  this.setState({ autoWithdrawNetwork: network });
                }
              }}
            />
            <label
              htmlFor={`autoWithdraw${statePrefix}`}
              style={{
                fontSize: "13px",
                color: "var(--text-color)",
                margin: 0,
                cursor: (!addressValue || validStatus === "invalid") ? "not-allowed" : "pointer",
                opacity: (!addressValue || validStatus === "invalid") ? 0.5 : 1,
              }}
            >
              Use for Automatic Withdrawal
            </label>
          </div>
        )}
      </div>
    );
  };

  render() {
    const showMemoField =
      this.state.selectedAsset.assetCode === "HCX" ||
      this.state.selectedAsset.assetCode === "XRP";

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>
              <PageHeader
                icon="mdi-bitcoin"
                title="Add Crypto Address"
                subtitle="Manage your crypto asset addresses"
              />

              {/* ── Crypto Address Cards ── */}
              {this.state.assets.length === 0 && (
                <div style={styles.card}>
                  <div style={styles.emptyState}>
                    <div style={styles.emptyIcon}>
                      <i className="fa fa-wallet"></i>
                    </div>
                    <div style={{ fontSize: "14px" }}>No assets found</div>
                  </div>
                </div>
              )}

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                  gap: "20px",
                }}
              >
                {this.state.assets.map((iter) => (
                  <div
                    key={iter.assetId}
                    style={{
                      background: "var(--body-color-less)",
                      borderRadius: "16px",
                      border: "1px solid var(--body-color-less2)",
                      boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                      padding: "24px",
                      display: "flex",
                      flexDirection: "column",
                      transition: "box-shadow 0.2s, border-color 0.2s",
                    }}
                  >
                    {/* Asset Header */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "14px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          background: "var(--body-color)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          border: "1px solid var(--body-color-less2)",
                        }}
                      >
                        <img
                          src={iter.assetImage}
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                          }}
                          alt={iter.assetCode}
                        />
                      </div>
                      <div>
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "15px",
                            color: "var(--text-color)",
                            lineHeight: "1.2",
                          }}
                        >
                          {iter.assetName}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            opacity: 0.45,
                            color: "var(--text-color)",
                            marginTop: "2px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {iter.assetCode}
                        </div>
                      </div>
                    </div>

                    {/* Network Info */}
                    {iter.network && (
                      <div
                        style={{
                          background: "var(--body-color)",
                          borderRadius: "12px",
                          padding: "14px 18px",
                          marginBottom: "18px",
                          border: "1px solid var(--body-color-less2)",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            opacity: 0.45,
                            color: "var(--text-color)",
                            marginBottom: "4px",
                          }}
                        >
                          Network
                        </div>
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            color: "var(--text-color)",
                          }}
                        >
                          {iter.network}
                        </div>
                      </div>
                    )}

                    {/* Balance */}
                    <div
                      style={{
                        background: "var(--body-color)",
                        borderRadius: "12px",
                        padding: "14px 18px",
                        marginBottom: "18px",
                        border: "1px solid var(--body-color-less2)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "11px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          opacity: 0.45,
                          color: "var(--text-color)",
                          marginBottom: "6px",
                        }}
                      >
                        Balance
                      </div>
                      <div
                        style={{
                          fontFamily:
                            "'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace",
                          fontWeight: "700",
                          fontSize: "20px",
                          color: "var(--text-color)",
                          lineHeight: "1.2",
                        }}
                      >
                        {iter.coinBalance}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          opacity: 0.5,
                          color: "var(--text-color)",
                          marginTop: "2px",
                        }}
                      >
                        {iter.assetCode}
                      </div>
                    </div>

                    {/* Add Address Button */}
                    <button
                      type="button"
                      style={{
                        width: "100%",
                        padding: "12px 24px",
                        background: "var(--btn-color)",
                        color: "#fff",
                        borderRadius: "12px",
                        fontSize: "14px",
                        fontWeight: "600",
                        border: "none",
                        cursor:
                          this.state.permission == "WRITE"
                            ? "pointer"
                            : "not-allowed",
                        opacity: this.state.permission == "WRITE" ? 1 : 0.5,
                        transition: "opacity 0.2s",
                        marginTop: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                      disabled={this.state.permission != "WRITE"}
                      onClick={() => {
                        this.handleGetAddress(iter);
                      }}
                    >
                      <i
                        className="fa fa-plus"
                        style={{ fontSize: "12px" }}
                      ></i>
                      Add Address
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <Footer />
          </div>

          {/* ── Add/Edit Address Modal ── */}
          <Modal
            show={this.state.showAddAddressModal}
            backdrop="static"
            keyboard={false}
            centered
          >
            <div style={styles.modalOverlay}>
              <div style={styles.modalHeader}>
                <div style={{ ...styles.cardHeaderIcon, ...styles.iconPurple }}>
                  <i className="fa fa-pen"></i>
                </div>
                <div style={styles.modalTitle}>
                  {this.state.selectedAsset.assetName} Address
                </div>
              </div>
              <div style={styles.modalBody}>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Address Name</label>
                    <input
                      type="text"
                      style={styles.input}
                      placeholder="Enter Address Name"
                      value={this.state.selectedAddressName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^[a-zA-Z0-9_ ]{0,100}$/.test(value)) {
                          this.setState({ selectedAddressName: value });
                        }
                      }}
                      onKeyUp={this.handleAddressNameKeyUp}
                    />
                    {this.state.addressNameError && (
                      <div
                        style={{
                          fontSize: "12px",
                          marginTop: "6px",
                          color: "#dc2626",
                        }}
                      >
                        {this.state.addressNameError}
                      </div>
                    )}
                  </div>

                  {/* Memo Field - Only show for HCX and XRP */}
                  {showMemoField && (
                    <div style={styles.formGroup}>
                      <label style={styles.label}>
                        Memo / Destination Tag
                        <span style={{ color: "#dc2626", marginLeft: "4px" }}>*</span>
                      </label>
                      <input
                        type="text"
                        style={styles.input}
                        placeholder={
                          this.state.selectedAsset.assetCode === "XRP"
                            ? "Enter Destination Tag"
                            : "Enter Memo"
                        }
                        value={this.state.selectedMemo}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || /^[a-zA-Z0-9]{0,30}$/.test(value)) {
                            this.setState({ selectedMemo: value });
                          }
                        }}
                        onKeyUp={this.handleMemoKeyUp}
                      />
                      {this.state.memoError && (
                        <div
                          style={{
                            fontSize: "12px",
                            marginTop: "6px",
                            color: "#dc2626",
                          }}
                        >
                          {this.state.memoError}
                        </div>
                      )}
                    </div>
                  )}

                  {String(this.state.currency_id) === "16" ? (
                    <Fragment>
                      {this.renderAddressInput("ERC", "USDT ERC Address")}
                      {this.renderAddressInput("TRC", "USDT TRC Address")}
                    </Fragment>
                  ) : (
                    this.renderAddressInput("", `${this.state.selectedAsset.assetName} Address`)
                  )}

                  <div style={styles.modalFooter}>
                    <button
                      type="button"
                      style={styles.btnPrimary}
                      onClick={this.handleSaveAddress}
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      style={styles.btnSecondary}
                      onClick={() => {
                        this.setState({
                          showAddAddressModal: false,
                          selectedAddress: "",
                          selectedAddressERC: "",
                          selectedAddressTRC: "",
                          selectedAddressName: "",
                          selectedMemo: "",
                          addressValidStatus: null,
                          addressValidStatusERC: null,
                          addressValidStatusTRC: null,
                          hadInitialNativeAddress: false,
                          hadInitialERCAddress: false,
                          hadInitialTRCAddress: false,
                        });
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Modal>

          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default CryptoAddress;